/**
 * Returns the value of a breakpoint min-width for a given size.
 * @param size Breakpoint size.
 * @returns Value of the breakpoint.
 * @throws {Error} If breakpoint does not exist.
 */
const getBreakpoint = (size) => {
    const value = parseFloat(getComputedStyle(document.body).getPropertyValue(`--bs-breakpoint-${size}`));
    if (isNaN(value)) {
        throw new Error(`Missing breakpoint '${size}'`);
    }
    return value;
};
export const Breakpoint = {
    XS: getBreakpoint('xs'),
    SM: getBreakpoint('sm'),
    MD: getBreakpoint('md'),
    LG: getBreakpoint('lg'),
    XL: getBreakpoint('xl'),
    XXL: getBreakpoint('xxl'),
};
